<template>
    <fragment>
      <div class="text-center mt-2" v-if="variablesLoading">
        <b-spinner
          variant="success"
          style="width: 2rem; height: 2rem;"
          label="Large Spinner"
        />
      </div>
      <template v-else>
        <vue-bootstrap-typeahead
          v-if="!selectedVariable"
          ref="variableSelector"
          class="mt-2"
          :data="primaryPickList"
          :serializer="
            (v) =>
              `Q${v.question.id}: ${v.question.prompt} / V${v.id}: ${v.input_label}`
          "
          @hit="onVariableSelect"
          placeholder="Type part of question prompt or variable input label..."
        >
          <template slot="suggestion" slot-scope="{ data }">
            <variable-display :variable="data" />
          </template>
        </vue-bootstrap-typeahead>
        <variable-display v-else class="mt-2" :variable="selectedVariable">
          <i
            slot="remove-icon"
            class="mdi mdi-close-circle-outline size-medium phairify-color-red"
            @click="$emit('set-visibility-condition', null)"
          />
        </variable-display>
      </template>
    </fragment>
  </template>
  
  <script>
  import GetVariableConditionItemsMixin from '@/mixins/GetVariableConditionItemsMixin';
  import VariableDisplay from '@/components/VariableDisplay';
  import VueBootstrapTypeahead from 'vue-typeahead-bootstrap';
  import { CONDITION_VARIANTS } from '@/store';
  import { GET_CONDITION_VARIABLES_ACTION } from '@/store/conditionVariables';
  
  export default {
    name: 'AnualizeVariableSelector',
    mixins: [GetVariableConditionItemsMixin],
    components: {
      VariableDisplay,
      VueBootstrapTypeahead,
    },
    props: {
      condition: Object,
      question: Object
    },
    data: function () {
      return {
        primaryPickList: [],
      };
    },
    created: function () {
      this.loadVariables();
    },
    computed: {
      variables: function () {
        return this.$store.getters.variablesVisibilityConditionItems;
      },
      selectedVariable: function () {
        return this.question.variables.find(({ id }) => id === this.question.annualized_question);
      },
      variablesLoading: function () {
        return this.$store.state.conditionVariables.loading;
      },
    },
    methods: {
      onVariableSelect: function (variable) {
        this.clearTypeaheadInput();
        this.$emit('set-visibility-condition', {
          variant: CONDITION_VARIANTS.VISIBILITY,
          variable_id: variable.id,
        });
      },
      loadVariables: async function () {
        this.$wait.start(this.loaderName);
        try {
          this.primaryPickList = await this.$store.dispatch(
            GET_CONDITION_VARIABLES_ACTION
          );
        } catch (e) {
          this.$toasted.error('Unable to upload variables for conditions', {
            duration: 3000,
          });
        } finally {
          this.$wait.end(this.loaderName);
        }
      },
      clearTypeaheadInput() {
        const typeahead = this.$refs.variableSelector;
        if (typeahead) {
          const input = typeahead.$el.querySelector('input');
          if (input) {
            input.value = ''; // Clear the input field
            // Optionally, you can trigger an input event if necessary
            const event = new Event('input', { bubbles: true });
            input.dispatchEvent(event);
          }
        }
      },
    },
  };
  </script>
  
  <style scoped>
  i.mdi.mdi-close-circle-outline {
    position: absolute;
    top: calc(50% - 22px);
    right: 0;
  }
  </style>
  